import {
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";

interface DocumentCardProps {
  title: string;
  date?: string;
  practitioner?: string;
  specialty?: string;
  status?: {
    text: string;
    color: string;
    icon: React.ReactElement;
  };
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export function DocumentCard({
  title,
  date,
  practitioner,
  specialty,
  status,
  actions,
  children,
}: DocumentCardProps) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: "100%",
        mb: 2,
        borderRadius: 2,
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
        position: "relative",
        overflow: "visible",
      }}
    >
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="h6">{title}</Typography>

          {date && (
            <Typography variant="body2" color="text.secondary">
              {date}
            </Typography>
          )}

          {practitioner && (
            <Typography variant="body2" color="text.secondary">
              Dr(a). {practitioner}
              {specialty && ` - ${specialty}`}
            </Typography>
          )}

          {status && (
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                icon={status.icon}
                label={status.text}
                size="small"
                sx={{
                  color: status.color,
                  backgroundColor: `${status.color}15`,
                }}
              />
            </Stack>
          )}

          {children}

          {actions && (
            <Stack
              direction="row"
              spacing={1}
              sx={{ mt: 1 }}
              justifyContent="flex-end"
            >
              {actions}
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
